import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getDatabase, ref, set as FirebaseSet } from 'firebase/database';
import initData from "./data/myplan-beta-default-rtdb-export.json";

export default function Login(props) {

    var currUser = props.currUser;
    const setUser = props.setUser;

    const resetData = () => {
        const db = getDatabase();
        const root = ref(db, "/");
        FirebaseSet(root, initData);
    }

    return (
        <div className="mainfunc-block">
            <section>
                <h2>
                    Choose a User
                </h2>
                <Link to='/schedule' type="button" className="btn btn-primary m-2" onClick={()=>{setUser({name: "testuser01"})}}>
                        User 1
                </Link>

                <Link to='/schedule' type="button" className="btn btn-primary m-2" onClick={()=>{setUser({name: "testuser02"})}}>
                        User 2
                </Link>
                <p>Current User is: {currUser.name}</p>
                <Link to='/schedule' type="button" className="btn btn-danger m-2" onClick={()=>{resetData()}}>
                    Reset all Data
                </Link>
            </section>  
        </div>
    );
}